import { render, staticRenderFns } from "./StaffIntro.vue?vue&type=template&id=22dc1a34&scoped=true&"
import script from "./StaffIntro.vue?vue&type=script&lang=js&"
export * from "./StaffIntro.vue?vue&type=script&lang=js&"
import style0 from "./StaffIntro.vue?vue&type=style&index=0&id=22dc1a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc1a34",
  null
  
)

export default component.exports